import {RootState} from '../../../../domain/app/store';

export const countrySearch = (state: RootState) => state.country.countrySearch;
export const selectedCountryRowKeys = (state: RootState) =>
  state.country.selectedRowKeys;
export const countriesTableLoading = (state: RootState) =>
  state.country.tableLoading;
export const regionsTableLoading = (state: RootState) =>
  state.country.regionsTableLoading;
export const countryRegionId = (state: RootState) => state.country.regionId;
export const isEditRegionModal = (state: RootState) => !!state.country.regionId;
export const isRegionModalOpened = (state: RootState) =>
  state.country.isRegionModalOpened;
export const paginateData = (state: RootState) => state.country.paginate;
